import { all, put, call, takeEvery, takeLatest } from "redux-saga/effects";
import api_service from "../../network/api_callbacks";
import {
    GET_QUESTIONS_REQUEST,
    getQuestionsSuccess,
    getQuestionsFailure
} from "../actions/getQuestions"

function* getQuestionsSaga(action) {
    try {
        const response = yield call(api_service.getQuestions, action.payload);
        yield put(getQuestionsSuccess(response));
    } catch (err) {
        console.log(err);
        yield put(getQuestionsFailure(err.response?.data?.message || 'failed'));
    }
}

export default function* watchGetQuestionsSaga() {
    yield takeEvery(GET_QUESTIONS_REQUEST, getQuestionsSaga);
}
